import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { Origin } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class OriginService extends TmsWebBaseEditService<Origin, Origin> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('Origin', $localize`Origin`, httpService, notificationService);
  }
}
